import { render } from "./HeroiconsSolidStop.vue?vue&type=template&id=9366d93a"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidStop.vue"]])

export default __exports__